import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MonthlyReportModal } from './MonthlyReportModal';

interface ReportsSectionProps {
  businessProfileId?: string;
  isCollapsed?: boolean;
  onToggle?: () => void;
}

export function ReportsSection({
  businessProfileId,
  isCollapsed = false,
  onToggle,
}: ReportsSectionProps) {
  const { t } = useTranslation();
  const [showReportModal, setShowReportModal] = useState(false);

  return (
    <div className="bg-brand-primary-deep rounded-lg overflow-hidden">
      {/* Section Header */}
      <button
        onClick={onToggle}
        className="w-full flex items-center justify-between px-4 py-3 hover:bg-white/10 transition-colors"
      >
        <div className="flex items-center gap-3">
          <svg className="w-5 h-5 text-brand-confirm" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
          <span className="text-lg font-medium text-white">
            {t('reports.title', 'Raporty Miesięczne')}
          </span>
        </div>
        <svg
          className={`w-5 h-5 text-white/70 transition-transform ${isCollapsed ? '' : 'rotate-180'}`}
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {/* Section Content */}
      {!isCollapsed && (
        <div className="px-4 pb-4 space-y-4">
          <div className="bg-surface-card rounded-lg p-4">
            <p className="text-sm text-ink-secondary mb-4">
              {t('reports.description', 'Przeglądaj miesięczne raporty przychodów, rezerwacji i zakupów usług.')}
            </p>

            <button
              onClick={() => setShowReportModal(true)}
              className="flex items-center gap-2 px-4 py-2 rounded-lg bg-brand-confirm text-white hover:bg-brand-confirm-deep transition-colors text-sm font-medium"
            >
              <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              {t('reports.viewReport', 'Wyświetl raport')}
            </button>
          </div>
        </div>
      )}

      {/* Report Modal */}
      {showReportModal && businessProfileId && (
        <MonthlyReportModal
          businessProfileId={businessProfileId}
          onClose={() => setShowReportModal(false)}
        />
      )}
    </div>
  );
}
